import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { hydrate } from "@/lib";
import { fetchMessageText } from "./thunk";

export interface MessageTextState {
  messageText: { [key: string]: string | number | boolean | null };
  error: string | null;
  status: "idle" | "fetching" | "saving";
}

const initialState: MessageTextState = {
  messageText: {},
  error: null,
  status: "idle"
};

export const messageTextSlice = createSlice({
  name: "messageText",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(hydrate, (state, action: PayloadAction<string>) => {
        return {
          ...state,
          ...action.payload[messageTextSlice.name]
        };
      })
      .addCase(fetchMessageText.pending, (state) => {
        state.status = "fetching";
      })
      .addCase(fetchMessageText.fulfilled, (state, action) => {
        state.status = "idle";
        state.messageText = action.payload;
      })
      .addCase(fetchMessageText.rejected, (state, action) => {
        state.status = "idle";
        state.error = action.error.message;
      });
  }
});
